<template>
  <svg class="summary-icon" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M8.00001 2.44629V13.553L7.46667 14.1596C6.72667 14.9996 6.12001 14.773 6.12001 13.653V8.85296H4.06001C3.12667 8.85296 2.86667 8.27962 3.48667 7.57962L8.00001 2.44629Z"
      :fill="props.primaryColor"
    />
    <path
      opacity="0.4"
      d="M12.5133 8.42026L8 13.5536V2.44692L8.53333 1.84026C9.27333 1.00026 9.88 1.22692 9.88 2.34692V7.14692H11.94C12.8733 7.14692 13.1333 7.72026 12.5133 8.42026Z"
      :fill="props.secondaryColor"
    />
  </svg>
</template>

<script setup>
/* global defineProps */
const props = defineProps({
  primaryColor: {
    type: String,
    default: '#3C67D6'
  },
  secondaryColor: {
    type: String,
    default: '#3C67D6'
  },
  secondaryOpacity: {
    type: Number,
    default: 0.4
  }
})

</script>
